import { BaseApi } from "./base";

export class I18nApi extends BaseApi {
  constructor() {
    super({ baseURL: "/i18n" });
  }

  async get(key) {
    return super.get(`/frontend.${key}`);
  }
}

let api;

export const useI18nApi = () => {
  api ??= new I18nApi();

  return {
    all: async (key) => api.get(key),
  };
};
